import type { UI } from '@/v2/types';

import { BEST_RATE_ID } from '@shared/v2/constants/packages';
import useCheapestAlternativeOffer from '@shared/v2/hooks/useCheapestAlternativeOffer';
import useSearchQuery from '@shared/v2/hooks/useSearchQuery';

import useProcuredOffer from '@/components/PackagePage/hooks/useProcuredOffer';
import usePropertyContent from '@/components/PackagePage/hooks/usePropertyContent';
import { useRoomOptionsData } from '@/v2/components/pages/PackageView/contexts/RoomOptionsContext';

const useAlternativeOffer = () => {
  const { setSearchQuery } = useSearchQuery();
  const { packageOffers, packageOptions } = useRoomOptionsData() || {};
  const propertyContent: UI.Property = usePropertyContent();
  const procuredOffer: UI.ProcuredOffer | undefined = useProcuredOffer();

  const cheapestAlternativeOffer = useCheapestAlternativeOffer({
    packageOffers: packageOffers,
    roomTypes: propertyContent?.roomTypes,
    procuredOfferRooms: procuredOffer?.rooms,
  });

  const matchingPackageOption = packageOptions?.find(
    (packageOption) =>
      packageOption.id ===
      cheapestAlternativeOffer?.leadInOffer?.inclusionSetId,
  );

  const handleSelectAltOffer = () => {
    return setSearchQuery({
      packageOption:
        cheapestAlternativeOffer?.leadInOffer?.inclusionSetId ?? BEST_RATE_ID,
      room: cheapestAlternativeOffer?.roomType?.id,
    });
  };

  return {
    alternativeOffer: cheapestAlternativeOffer,
    handleSelectAltOffer,
    alternativeOfferPackageOption: matchingPackageOption,
  };
};

export default useAlternativeOffer;
